import { render, staticRenderFns } from "./physicalAddressDialog.vue?vue&type=template&id=53818888&scoped=true&"
import script from "./physicalAddressDialog.vue?vue&type=script&lang=tsx&"
export * from "./physicalAddressDialog.vue?vue&type=script&lang=tsx&"
import style0 from "./physicalAddressDialog.vue?vue&type=style&index=0&id=53818888&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53818888",
  null
  
)

export default component.exports